import jaroWinkler from 'jaro-winkler';

const normalize = (str: string) =>
  str
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[^a-z]/g, '');

const calculateStringSimilarity = (aadharName: string, enteredName: string) => {
  const cleanedAadharName = aadharName.toLowerCase().trim();
  const cleanedEnteredName = enteredName.toLowerCase().trim();

  const aName = normalize(cleanedAadharName);
  const eName = normalize(cleanedEnteredName);

  const similarity = jaroWinkler(aName, eName);
  // const isNameSimilar = similarity >= 0.8;
  const lengthPenalty = Math.abs(aName.length - eName.length) / Math.max(aName.length, eName.length);
   const adjustedSimilarity = similarity - lengthPenalty;
  const isNameSimilar = adjustedSimilarity > 0.8;
  return isNameSimilar;
}

export default calculateStringSimilarity;